import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
    getFormCopyright,
    getFormInstructions,
    getFormOrgData,
    getFormSortedCustomerIdentification,
} from '../../store/selectors/form.selector';
import { FormsState } from '../../store/state/pace-forms.state';
import { Copyright } from '../../types/copyright';
import { SortedCustomerIdentificationInputField } from '../../types/customer-identification-input-field';
import { OrgData } from '../../types/org-data';

@Component({
    selector: 'pace-forms-customer-identification',
    templateUrl: './customer-identification.component.html',
    styleUrls: ['./customer-identification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerIdentificationComponent {
    @Input()
    public parentForm: FormArray;

    public orgData$: Observable<OrgData>;
    public copyright$: Observable<Copyright>;
    public instructions$: Observable<string | undefined>;
    public sortedInputFields$: Observable<SortedCustomerIdentificationInputField[]>;
    public constructor(private readonly store: Store<FormsState>) {
        this.orgData$ = this.store.select(getFormOrgData);
        this.copyright$ = this.store.select(getFormCopyright);
        this.instructions$ = this.store.select(getFormInstructions);
        this.sortedInputFields$ = this.store.select(getFormSortedCustomerIdentification);
    }

    public trackByFn(index: number, item: SortedCustomerIdentificationInputField): string {
        return item.xmlId;
    }
}
